import { runJsonGet } from '@/backend-client'
import { OPERATIONS_BACKEND_URL } from '@/config'
import { transformKeysToCamelCase, transformKeysToSnakeCase } from './utils/casing'

export const fetchTransports = async (queryParams = {}) => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/filtering/queries/order-list`,
    transformKeysToSnakeCase(queryParams)
  )
  return transformKeysToCamelCase(data)
}

export const fetchTransportDetails = async id => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/ordering-carrier/queries/order-details/${id}`
  )
  return transformKeysToCamelCase(data)
}

export const fetchDispatchingConfirmationDetails = async id => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/order-confirmation/queries/get-order-confirmation/${id}`
  )
  return transformKeysToCamelCase(data)
}
